class Accordion {
    constructor(element) {
        this.el = element;

        this.init();
    }

    init() {
        this.addHeightProperties();
    }

    addHeightProperties() {
        let height;
        const wysiwygContent = this.el.querySelector(".wysiwyg-content");

        if (wysiwygContent) {
            height = getComputedStyle(wysiwygContent).height;
        } else {
            height = this.el.offsetHeight;
        }

        this.el.style.setProperty("--true-height", height + "px");
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const accordionElements = document.querySelectorAll(
        ".accordion-content-outer, .event-information__application--details",
    );

    accordionElements.forEach((element) => {
        new Accordion(element);
    });
});

export default Accordion;
